import { LanguageEnum } from 'gleblu-socket-api';

import Language from '../languages/Language';
import supportedLocalizations from './supportedLocalizations';

const supportedLanguages: Record<LanguageEnum, Language> = {
  [LanguageEnum.ENGLISH]: supportedLocalizations[LanguageEnum.ENGLISH].language,
  [LanguageEnum.ROMANIAN]: supportedLocalizations[LanguageEnum.ROMANIAN].language,
  [LanguageEnum.HUNGARIAN]: supportedLocalizations[LanguageEnum.HUNGARIAN].language,
};

export default supportedLanguages;
